import type { MutableRefObject } from 'react'
import { useRef } from 'react'

/**
 * Позволяет использовать самое последние значение внутри callback,
 * не вызывая лишних ререндеров и обновлений
 *
 * @param value значение для установки/обновления
 * @returns ссылка на самое последнее значение
 */
export const useLatest = <T>(value: T): MutableRefObject<T> => {
  const valueRef = useRef<T>(value)
  valueRef.current = value
  return valueRef
}
